import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import '../../assets/css/animate.css';
import store from './store/store';
import ErrorBoundary from './ErrorBoundary';
import { initializeGTM } from './common/analytics'
import IndexWrapper from 'indexWrapper';
import { createRoot } from 'react-dom/client';

import {SocketContext , socket} from 'context/socket'

initializeGTM();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <SocketContext.Provider value={socket}>
        <ErrorBoundary>
            <Provider store={store}>
                <Router>
                    <IndexWrapper />
                </Router>
            </Provider>
        </ErrorBoundary>
    </SocketContext.Provider>);